import { render, staticRenderFns } from "./OrderStatusHeader.vue?vue&type=template&id=e34af082&scoped=true"
import script from "./OrderStatusHeader.vue?vue&type=script&lang=js"
export * from "./OrderStatusHeader.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusHeader.vue?vue&type=style&index=0&id=e34af082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34af082",
  null
  
)

export default component.exports